import { Eye } from 'lucide-react';

export function ProfileSkeleton() {
  return (
    <li className="flex animate-pulse items-center gap-[25px] border-b px-5 py-[14px]">
      <div>
        <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-sm font-medium" />
      </div>

      <div className="flex flex-col gap-2">
        <span className="h-[17px] w-[200px] bg-gray-100 text-sm" />
        <span className="text-xsh-[15px] w-[140px] bg-gray-100 text-muted-foreground" />
      </div>

      <div className="flex flex-col gap-2">
        <span className="h-[17px] w-[200px] bg-gray-100 text-sm" />
        <span className="h-[15px] w-[100px] bg-gray-100 text-xs text-muted-foreground" />
      </div>

      <ul className="flex flex-1 gap-1">
        <li>
          <span className="h-[23px] w-[80px] rounded-full bg-gray-100 py-1 text-xs text-muted-foreground" />
        </li>

        <li>
          <span className="h-[23px] w-[60px] rounded-full bg-gray-100 py-1 text-xs text-muted-foreground" />
        </li>

        <li>
          <span className="h-[23px] w-[50px] rounded-full bg-gray-100 py-1 text-xs text-muted-foreground" />
        </li>
      </ul>

      <button className="cursor-not-allowed">
        <Eye className="h-6 w-6" />
      </button>
    </li>
  );
}
